import { forwardRef } from "react"
import styled from "styled-components"
import { Typography } from "../../../typography"
const CheckOff =
  "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3LjI1MDIgMTkuMjVINi43NUM1LjY0NTQzIDE5LjI1IDQuNzUgMTguMzU0NiA0Ljc1IDE3LjI1VjYuNzVDNC43NSA1LjY0NTQzIDUuNjQ1NDMgNC43NSA2Ljc1IDQuNzVIMTcuMjUwMkMxOC4zNTQ4IDQuNzUgMTkuMjUwMiA1LjY0NTQzIDE5LjI1MDIgNi43NVYxNy4yNUMxOS4yNTAyIDE4LjM1NDYgMTguMzU0OCAxOS4yNSAxNy4yNTAyIDE5LjI1WiIgc3Ryb2tlPSJjdXJyZW50Y29sb3IiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="
const CheckOn =
  "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3LjI1MDIgMTkuMjVINi43NUM1LjY0NTQzIDE5LjI1IDQuNzUgMTguMzU0NiA0Ljc1IDE3LjI1VjYuNzVDNC43NSA1LjY0NTQzIDUuNjQ1NDMgNC43NSA2Ljc1IDQuNzVIMTcuMjUwMkMxOC4zNTQ4IDQuNzUgMTkuMjUwMiA1LjY0NTQzIDE5LjI1MDIgNi43NVYxNy4yNUMxOS4yNTAyIDE4LjM1NDYgMTguMzU0OCAxOS4yNSAxNy4yNTAyIDE5LjI1WiIgc3Ryb2tlPSJjdXJyZW50Y29sb3IiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTguNzUgMTJMMTEgMTQuMjVMMTUuMjUgOS43NSIgc3Ryb2tlPSJjdXJyZW50Y29sb3IiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="

export const CheckboxFieldSet = styled.fieldset`
  border: none;
  padding: 0;
  margin: 0;
`

const CheckboxInput = styled.input`
  position: absolute;
  left: 0;
  opacity: 0;
`

const CheckboxLabel = styled(Typography).attrs(() => ({
  $variant: "body-4-medium",
}))`
  color: ${({ theme }) => theme.colors.grey.$600};

  height: 2.5rem;
  display: inline-flex;
  align-items: center;
  padding: 0 0 0 1.5rem;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;

  position: relative;

  transition: all 0.2s ease;
  box-sizing: border-box;
  border: 1px solid transparent;

  cursor: pointer;

  &::before {
    content: "";
    position: absolute;
    left: -0.125rem;
    top: 0;
    width: 1.5rem;
    height: 2.5rem;
    mask-image: url(${CheckOff});
    mask-repeat: no-repeat;
    mask-size: 1.5rem;
    mask-position: center;
    background-color: ${({ theme }) => theme.colors.grey.$600};
  }

  ${CheckboxInput}:checked + &::before {
    mask-image: url(${CheckOn});
  }

  ${CheckboxInput}:active + & {
    border: 1px solid ${({ theme }) => theme.colors.grey.$600};
  }

  ${CheckboxInput}:focus + & {
    outline: 2px solid ${({ theme }) => theme.colors.grey.$400};
    border: 1px solid ${({ theme }) => theme.colors.grey.$200};
  }

  ${CheckboxInput}:disabled + & {
    color: ${({ theme }) => theme.colors.grey.$400};
  }

  ${CheckboxInput}:disabled + &::before {
    background-color: ${({ theme }) => theme.colors.grey.$400};
  }
`

const CheckboxContainer = styled.div``

export type CheckboxProps = {
  text: React.ReactNode
  id: string
  labelProps?: React.HTMLProps<HTMLLabelElement> & { as?: React.ElementType }
  containerProps?: React.HTMLProps<HTMLLabelElement> & { as?: React.ElementType }
  as?: React.ElementType
} & React.HTMLProps<HTMLInputElement>

export const Checkbox = forwardRef(
  ({ value, text, id, labelProps = {}, containerProps, ...props }: CheckboxProps, ref) => {
    return (
      <CheckboxContainer {...containerProps}>
        <CheckboxInput id={id} type="checkbox" value={value} {...props} ref={ref} />
        <CheckboxLabel htmlFor={id} as="label" {...labelProps}>
          {text}
        </CheckboxLabel>
      </CheckboxContainer>
    )
  },
)
